import {
  CrossVisitByLocationRequest,
  CrossVisitPlaceDate,
  CrossVisitRequest,
  CrossVisitByLocationResponse,
  CrossVisitsByPlace,
  AMMobilityBrandCrossVisitationRequest,
  AMMobilityBrandCrossVisitationResponse,
} from 'src/common-services/types/cross-visits-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class CrossVisitClient extends BaseClient {
  getPlacesDates(): Promise<CrossVisitPlaceDate[]> {
    return this.call<CrossVisitPlaceDate[]>('/cross-visits/place-dates', 'GET')
  }
  // Takes a venueId -> placeKey -> cross visitation
  getCrossVisitsByPlace(request: Omit<CrossVisitRequest, 'end'>): Promise<CrossVisitsByPlace[]> {
    return this.call(`/cross-visits/${encodeURIComponent(request.venueId)}/place`, 'GET', {
      params: {
        start: request.start,
      },
    })
  }

  // Takes a venueId -> placeKey -> cross visitation
  getCrossVisitsByLocation(request: CrossVisitByLocationRequest): Promise<CrossVisitByLocationResponse> {
    return this.call(`/cross-visits/${encodeURIComponent(request.locationId)}/location`, 'GET', {
      params: {
        provider: request.provider,
        start: request.start,
        end: request.end,
      },
    })
  }

  getCrossVisitationByBrandId(
    request: AMMobilityBrandCrossVisitationRequest
  ): Promise<AMMobilityBrandCrossVisitationResponse> {
    return this.call(`/cross-visits/brand/${request.brandId}`, 'POST', {
      data: request,
    })
  }
}
